<script lang="ts">
  import { onMount } from "svelte";
  import { _ } from "svelte-i18n";
  import { dataset_dev, getContext, listen } from "svelte/internal";
  const jq = window.$;
  
  export let files;
  export let initial_files = [];
  export let form_id;
  export let files_to_delete = [];

  let file_input: HTMLInputElement;
  let file_input_string: string;
  function on_input(_str: string) {
    console.log(file_input.files);
    if (file_input.files != null && file_input.files.length > 0)
      files = file_input.files;
  }
  $: if(file_input != null) on_input(file_input_string);
  
  let request: RequestInit = getContext('fetch-request');
  delete request.headers["Content-Type"];
  onMount(()=>{
    jq('input.files').fileuploader({
      extensions: ['image/*'],
      addMore: true,
      theme: "dragdrop",
      inputNameBrackets: true, // For PHP backend.
      upload: false,
      /*
      upload: {
        url: upload_url,
        type: "POST",
        enctype: 'multipart/form-data',
        start: true,
        beforeSend(item){
          console.log("Uploading image:");
          console.log(item);
          console.log([...item.upload.formData.entries()]);
          return true;
        },
        onSuccess(data, item){
          console.log("Image uploaded! ");
          console.log(item)
        }
      },*/
      changeInput:
       '<div class="fileuploader-input">' +
          '<div class="fileuploader-input-inner">' +
          '<h3 class="fileuploader-input-caption"><span>${captions.feedback}</span></h3>' +
          '<p>${captions.or}</p>' +
          '<button type="button" class="fileuploader-input-button"><span>${captions.button}</span></button>' +
          '</div>' +
        '</div>',
      captions: jq.extend(true, {}, jq.fn.fileuploader.languages['en'], {
          feedback: 'Drag and drop files here',
          feedback2: 'Drag and drop files here',
          drop: 'Drag and drop files here',
          or: 'or',
          button: 'Browse files',
      }),
      files: initial_files?.map((url, i)=>{
        return {
          name: $_('sessions.editor.image_name', {values: {i: i+1}}),
          file: url,
          size: 0,
          type: 'image/*',
          data: {
            thumbnail: url,
          }
        }
      }),
      /*
      editor: {
        cropper: {
          ratio: '1:1',
          minWidth: 100,
          minHeight: 100,
          showGrid: true
        }
      },*/
      onRemove(item) {
        if (item?.data?.url != null) {
          let name=item.data.url.split('/').pop();
          //let url = `${upload_url}/${name}`;
          files_to_delete.push(name);
        }
        /*
        window.fetch(url, {
          method: 'delete',
          headers: headers,
          credentials: "same-origin",
        }).then(response => response.json())
        .then(data => {
        }).catch(error =>{
        });
        */
      }
    });
    
    /*
    .fileuploader({
      // Options will go here
      editor: {
        // editor cropper
        cropper: {
          // cropper ratio
          // example: null
          // example: '1:1'
          // example: '16:9'
          // you can also write your own
          ratio: null,
          
          // cropper minWidth in pixels
          // size is adjusted with the image natural width
          minWidth: null,
          
          // cropper minHeight in pixels
          // size is adjusted with the image natural height
          minHeight: null,
          
          // show cropper grid
          showGrid: true
        },
        
        // editor on save quality (0 - 100)
        // only for client-side resizing
        quality: null,
        
        // editor on save maxWidth in pixels
        // only for client-side resizing
        maxWidth: null,
        
        // editor on save maxHeight in pixels
        // only for client-size resizing
        maxHeight: null,
        
        // Callback fired after saving the image in editor
        onSave: function(blobOrDataUrl, item, listEl, parentEl, newInputEl, inputEl) {
          // callback will go here
        }
      }
    });*/
    
  })
  
</script>

<!-- file input -->
<input type="file" bind:this={file_input} bind:value={file_input_string} name="files" class="files" form="{form_id}">

<!--form action={upload_url} method="post" enctype="multipart/form-data">
</form-->

<style lang="scss">
  :global(div.fileuploader-popup) {
    z-index: 9999;
  }
  form {
    width: 100%;
  }
  // Base drag and drop theme copied from example:
  // https://innostudio.de/fileuploader/documentation/examples/drag-drop/
  :global {
    /* Root element */
    .fileuploader-theme-dragdrop.fileuploader {
      margin: 24px 0;
      padding: 0;
      text-align: center;
      background: none;
    }
    /* input */
    .fileuploader-theme-dragdrop .fileuploader-input {
      display: block;
      padding: 16px;
      text-align: center;

      background: rgba(47, 112, 118, 0.05);
      border: 1px dashed #979797;
      box-sizing: border-box;
      border-radius: 3px;
    }

    .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-input-button {
      background: #2F7076;
      border-radius: 4px;
      margin: 0;
      padding: 0;
      width: 191px;
      height: 30px;
      > span {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 19px;
        text-align: center;
        letter-spacing: 0.48px;

        color: #FFFFFF;
      }

    }
    .fileuploader-theme-dragdrop .fileuploader-input h3 {
      margin: 0;
      margin-bottom: 8px;
      padding: 0;
      background: none;
      border: none;
      border-radius: 0;

      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 0.113198px;

      color: #3D3D3D;


    }
    .fileuploader-theme-dragdrop .fileuploader-input p {
      margin: 0;
      padding: 0;
      color: #90a0bc;
      margin-bottom: 12px;
    }

    /* dragging state */
    .fileuploader-theme-dragdrop .fileuploader-input .fileuploader-input-inner > * {
        -webkit-transition: 500ms cubic-bezier(0.17, 0.67, 0, 1.01);
                transition: 500ms cubic-bezier(0.17, 0.67, 0, 1.01);
    }
    .fileuploader-theme-dragdrop .fileuploader-input.fileuploader-dragging .fileuploader-input-inner > * {
      transform: translateY(18px);
      opacity: 0;
    }
    .fileuploader-theme-dragdrop .fileuploader-input.fileuploader-dragging .fileuploader-icon-main {
      transform: translateY(30px) scale(1.2);
      opacity: 0.6;
    }
    .fileuploader-theme-dragdrop .fileuploader-input.fileuploader-dragging .fileuploader-input-caption {
      transform: translateY(30px);
      opacity: 0.6;
    }

    .fileuploader-theme-dragdrop .fileuploader-items {
      max-height: 250px;
      overflow: hidden auto;
      
    }
  }
</style>
